<template>
  <section class="pay">
    <div class="header">在线付款</div>
    <div class="box">
      <div class="item first">
        <label>订单号</label>
        <div class="value">{{ordersn}}</div>
      </div>
      <div class="item" style="display:none;">
        <p>付款方式</p>
        <div class="itemRadioGroup">
          <el-radio-group v-model="payType" @change="changePayType">
            <el-radio label="1" border>微信支付</el-radio>
            <el-radio label="2" border>支付宝</el-radio>
          </el-radio-group>
        </div>
      </div>
    </div>
    <div class="btn">
      <van-button type="primary" size="large" @click="Pay()">立即支付</van-button>
    </div>
  </section>
</template>

<script>
import { encrypt, setCookie,NowTimeCode } from "@/utils";

export default {
  data() {
    return {
      ordersn: NowTimeCode(),
      payType: "1"
    };
  },
  computed: {
    wechatauthor() {
      return this.$store.state.wechat.wechatauthor;
    }
  },
  mounted: function() {
    this.ordersn = this.$route.params.order;
  },
  methods: {
    Pay() {
      if(!this.ordersn){
        this.$toast("订单数据不存在.");
        return false;
      }
      if (navigator.userAgent.match(/MicroMessenger/i) == 'MicroMessenger') {
        this.WechatPay();
      }else{
        this.AliPay();
      }
    },
    AliPay() {
      let params = {
        paySource: "mobile",
        ordersn: this.ordersn
      };
      this.$store.dispatch("alipay/fetchAlipayWap", { params }).then(() => {
        const div = document.createElement("div");
        div.innerHTML = this.$store.state.alipay.alipaywap;
        document.body.appendChild(div);
        document.forms[0].submit();
      });
    },
    WechatPay() {
      let url =
        "https://www.suhuishou.com/api/wechat/mp?ordersn=" +
        this.ordersn +
        "&openId=" +
        this.wechatauthor.openid;
      this.url = url;
      window.location = url;
    },
    WechatPayH5() {
      let url =
        "https://www.suhuishou.com/api/wechat/wap?ordersn=" + this.ordersn;
      this.url = url;
      window.location = url;
    },
    WechatSchemePay() {
      let params = {
        ordersn: this.ordersn
      };
      let _this = this;
      this.$store.dispatch("wechat/fetchWechatScheme", { params }).then(() => {
        let data = _this.$store.state.wechat.wechatscheme;
        if (data.result_code == "SUCCESS") {
          let scheme = JSON.stringify(data);
          setCookie("scheme", encrypt(scheme), true);
          let routeData = this.$router.resolve({
            name: "wechatScheme"
          });
          window.open(routeData.href, "_blank");
        } else {
          window.location.href = "https://www.suhuishou.com/pc/#/user";
        }
      });
    },
    changePayType(value) {
      this.payType = value;
    }
  }
};
</script>

<style>
.pay {
  background: #fff;
  padding: 0rem 0 1rem;
}
.pay .header {
  height: 0.6rem;
  line-height: 0.6rem;
  text-align: center;
  position: relative;
  background: #fff;
}
.pay .header .header-left {
  position: absolute;
  left: 0.1rem;
  top: 0.23rem;
}
.pay .box .first {
  display: flex;
  padding: 0.1rem 0.1rem;
}
.pay .box .first label {
  width: 1rem;
}
.pay .box .item:nth-child(2) {
  padding: 0.1rem;
}
.pay .box .item .itemRadioGroup {
  margin: 0.1rem 0;
}
.pay .btn {
  margin: 0.4rem 0.1rem 0.1rem 0.1rem;
}
</style>
